package app.bloomey.web.modules.feedback.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Feedback(
    @SerialName("_id")
    val id: String,
    val createdAt: Long,
    val email: String,
    val message: String,
    val reaction: String,
)